"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactHookForm = require("react-hook-form");
var yup = _interopRequireWildcard(require("yup"));
var _yup2 = require("@hookform/resolvers/yup");
var _ui = require("../../../../ui");
var _hooks = require("../../../../../hooks");
var _fields = require("../../../../fields");
var _validations = require("../../../../../validations");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Notification = (0, _styledComponents.default)(_ui.Notification)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 22px;\n"])));
var PLACEHOLDER = '*'.repeat(8);
var schema = yup.object().shape({
  password: (0, _validations.passwordValidation)().when('$currentPasswordFieldVisible', function (isVisible, schema) {
    return isVisible ? schema.required() : schema;
  }),
  newPassword: (0, _validations.passwordValidation)().test({
    name: 'newPassword',
    message: 'Should not be equal to Current Password field value',
    test: function test(value) {
      if (!value) return true;
      return this.parent.password !== value;
    }
  }).required(),
  confirmNewPassword: (0, _validations.confirmationValidation)({
    toField: 'newPassword',
    toFieldLabel: 'New Password'
  })
}).required();
var Component = function Component(_ref) {
  var currentPasswordFieldVisible = _ref.currentPasswordFieldVisible,
    submitLoading = _ref.submitLoading,
    submitSucceeded = _ref.submitSucceeded,
    emailConfirmed = _ref.emailConfirmed,
    onSubmit = _ref.onSubmit;
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  var _useForm = (0, _reactHookForm.useForm)({
      mode: 'all',
      resolver: (0, _yup2.yupResolver)(schema),
      defaultValues: {},
      context: {
        currentPasswordFieldVisible: currentPasswordFieldVisible
      }
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    formState = _useForm.formState,
    watch = _useForm.watch,
    reset = _useForm.reset;
  (0, _react.useEffect)(function () {
    if (submitSucceeded) reset({
      password: '',
      newPassword: '',
      confirmNewPassword: ''
    });
  }, [submitSucceeded]);
  var _useToggle = (0, _hooks.useToggle)(true),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    currentPasswordHidden = _useToggle2[0],
    toggleCurrentPasswordHidden = _useToggle2[1];
  var _useToggle3 = (0, _hooks.useToggle)(true),
    _useToggle4 = _slicedToArray(_useToggle3, 2),
    passwordHidden = _useToggle4[0],
    togglePasswordHidden = _useToggle4[1];
  var _useToggle5 = (0, _hooks.useToggle)(true),
    _useToggle6 = _slicedToArray(_useToggle5, 2),
    confirmPasswordHidden = _useToggle6[0],
    toggleConfirmPasswordHidden = _useToggle6[1];
  var isDirty = formState.isDirty;
  var passwordValue = watch('newPassword', '');
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: handleSubmit(onSubmit)
  }, !emailConfirmed && /*#__PURE__*/_react.default.createElement(Notification, {
    title: t('emailUnconfirmed'),
    content: t('emailUnconfirmedDescription'),
    type: "danger"
  }), /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, null, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, currentPasswordFieldVisible ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('currentPassword')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.PasswordInputGroupAddon, {
    addonType: "append",
    passwordHidden: currentPasswordHidden,
    togglePasswordHidden: toggleCurrentPasswordHidden
  }), /*#__PURE__*/_react.default.createElement(_fields.PasswordInputField, {
    control: control,
    inputProps: {
      passwordHidden: currentPasswordHidden,
      placeholder: PLACEHOLDER,
      name: 'password',
      disabled: !emailConfirmed
    }
  }))) : /*#__PURE__*/_react.default.createElement(Notification, {
    title: t('setPassword'),
    content: t('passwordAttention'),
    type: "danger"
  })))), /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, null, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('newPassword')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.PasswordInputGroupAddon, {
    addonType: "append",
    passwordHidden: passwordHidden,
    togglePasswordHidden: togglePasswordHidden
  }), /*#__PURE__*/_react.default.createElement(_fields.PasswordInputField, {
    control: control,
    inputProps: {
      passwordHidden: passwordHidden,
      placeholder: PLACEHOLDER,
      name: 'newPassword',
      autoComplete: 'new-password',
      disabled: !emailConfirmed
    }
  }))))), /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, null, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('confirmNewPassword')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.PasswordInputGroupAddon, {
    addonType: "append",
    passwordHidden: confirmPasswordHidden,
    togglePasswordHidden: toggleConfirmPasswordHidden
  }), /*#__PURE__*/_react.default.createElement(_fields.PasswordInputField, {
    control: control,
    inputProps: {
      passwordHidden: confirmPasswordHidden,
      placeholder: PLACEHOLDER,
      name: 'confirmNewPassword',
      disabled: !emailConfirmed
    }
  }))))), /*#__PURE__*/_react.default.createElement(_ui.PasswordStrength, {
    password: passwordValue
  }), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    color: "secondary",
    loading: submitLoading,
    disabled: !isDirty || !emailConfirmed,
    type: "submit"
  }, t(currentPasswordFieldVisible ? 'changePassword' : 'setPassword'))));
};
exports.Component = Component;